import React from "react";
import cl from "./AboutInfo.module.css";
import Aboutus from "../../../image/aboutus.jpg";

const AboutInfo = (props) => {
  return (
    <>
      <section className={cl.about}>
        <div
          style={{
            width: "330px",
            height: "330px",
            padding: "1rem 1rem",
            background: "var(--secondary)",
            borderRadius: "5px",
            boxSizing: "border-box",
          }}
        >
          <h1>Our history</h1>
          <p>{props.shopStory}</p>
        </div>
        <img className={cl.big_image} src={Aboutus} />
      </section>
      <br />
      <p
        style={{
          alignSelf: "center",
          width: "80%",
          textAlign: "center",
          padding: "4rem ",
          background: "var(--secondary)",
          borderRadius: "5px",
          boxSizing: "border-box",
          fontSize: "2rem",
          textTransform: "capitalize",
          color: "var(--tertiary)",
        }}
      >
        {props.shopMessage}
      </p>
    </>
  );
};

export default AboutInfo;
